module.exports = require('./helpers/bundle-url').getBundleURL('hcuA3') + "logo-dark.a922e36b.svg";